import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd } from "@/lib/seo";
import { FAQS_SHOPIFY_CRO } from "@/lib/service-content/faqs/shopify-cro";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/cro-shopify";

export const Route = createFileRoute("/es/cro-shopify")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: "Agencia CRO Shopify en México | Optimización de Conversión · Shugert",
    description: "CRO Shopify para marcas en México: medición, diagnóstico de fricción, PDP, colección, carrito y checkout, implementación nativa y reglas de decisión basadas en evidencia.",
    path: PATH,
    altPath: alternatePath(PATH, "en"),
    ogImage: "/og-cro-seo-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "CRO Shopify en México", path: PATH }]),
      faqJsonLd(FAQS_SHOPIFY_CRO.es),
      serviceJsonLd({
        name: "Agencia CRO Shopify en México",
        description: "Optimización de conversión Shopify para equipos en México y Latinoamérica que conecta medición, diagnóstico de fricción, hipótesis, implementación nativa, QA y reporte de decisión.",
        path: PATH,
        serviceType: "Agencia CRO Shopify",
        minPrice: 3000,
        maxPrice: 5000,
        unit: "PROJECT",
        deliverables: ["Revisión de medición", "Mapa de fricción", "Hipótesis priorizadas", "Implementación nativa", "Reporte de decisión"],
        locale: "es",
      }),
    ],
  }),
});
